const ROLES = {
  MEMBER: 'Member',
  VOLUNTEER: 'Volunteer',
  SECRETARY: 'Secretary',
  SECRETARY_ONLY: 'SecretaryOnly',
  ADMIN: 'Admin',
  SUPER_ADMIN: 'SuperAdmin'
}

export default function useUserRole() {
  const role = localStorage.role || ''

  const isUser = role === ROLES.MEMBER
  const isVolunteer = role === ROLES.VOLUNTEER
  const isSecretary = role === ROLES.SECRETARY || role === ROLES.SECRETARY_ONLY
  // Secretary who is also a regular member (has their own personal nominations), unlike SecretaryOnly
  const isSecretaryMember = role === ROLES.SECRETARY
  const isSuperAdmin = role === ROLES.SUPER_ADMIN
  const isAdmin = role === ROLES.ADMIN || isSuperAdmin
  const isSecretaryOrAdmin = isSecretary || isAdmin
  // CAM-1533: Secretary flagged by an admin; can switch between committees
  const isSuperSecretary = isSecretary && localStorage.is_super_secretary === 'true'
  // True while a Super Secretary works on a committee other than their own: Committee page is
  // read-only and Draft Setup is closed (the API enforces both).
  let actingCommitteeId = null
  try {
    actingCommitteeId = (JSON.parse(localStorage.getItem('actingCommittee') || 'null') || {}).id || null
  } catch (_) {
    actingCommitteeId = null
  }
  const isActingForOtherCommittee = isSuperSecretary && !!actingCommitteeId &&
    String(actingCommitteeId) !== String(localStorage.own_committee_id || '')

  return { role, isUser, isVolunteer, isSecretary, isSecretaryMember, isAdmin, isSuperAdmin, isSecretaryOrAdmin, isSuperSecretary, isActingForOtherCommittee }
}



// WEBPACK FOOTER //
// ./src/composables/useUserRole.js